




import echarts, { EChartOption } from 'echarts'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from './mixins/resize'
export interface ILineChartData {
  dealerCode: any[]
}
@Component({
  name: 'LineChart',
})
export default class extends mixins(ResizeMixin) {
  @Prop({ required: true }) private chartTitle!: string
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '350px' }) private height!: string
  @Prop({ required: true }) private dataCharts
  @Watch('dataChart', { deep: true })
  private onChartDataChange(value: ILineChartData) {
    this.setOptions(value)
  }
  // tslint:disable-next-line:member-ordering
  public mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  // tslint:disable-next-line:member-ordering
  public beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }
  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.setOptions(this.dataCharts)
  }
  public getRandomColor() {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }
  public get colorValue() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push({
        value: item.value,
        itemStyle: { color: this.getRandomColor() },
      })
    }
    return array
  }
  public get dealerCode() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.dealerCode)
    }
    return array
  }

  private setOptions(dataChart: ILineChartData) {
    if (this.chart) {
      const dealerData: any = this.dataCharts
      this.chart.setOption({
        xAxis: {
          data: this.dealerCode,
          boundaryGap: true,

          axisTick: {
            show: true,
          },
          show: true,
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true,
        },
        tooltip: {
          formatter(params: any) {
            const res = params.name.replace(/\D/g, '')
            const data: any = dealerData.filter(
              (item) => item.dealerCode === res
            )

            return (
              'Dealer Name : ' +
              data[0].dealerName +
              '<br/>' +
              'Dealer City : ' +
              data[0].dealerCity +
              '<br/>' +
              'Dealer Code : ' +
              data[0].dealerCode +
              '<br/>' +
              'Total Access : ' +
              params.value
            )
          },
          trigger: 'item',
          renderMode: 'html',
        },
        yAxis: {
          axisTick: {
            show: true,
          },
        },
        legend: {},
        series: [
          {
            name: this.chartTitle,
            data: this.colorValue,
            itemStyle: { color: '#D6D6D6' },
            type: 'bar',
            animationDuration: 2800,
            animationEasing: 'quadraticOut',
            barMaxWidth: 50,
          },
        ],
      } as EChartOption<EChartOption.SeriesBar>)
    }
  }
}
